import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e8c7856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between w-full mb-4 mt-1 gap-2" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "font-semibold text-base" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "font-weight-bold" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-left text-sm font-semibold text-[#68688D]" }, "Formações inativas", -1))
const _hoisted_9 = {
  class: "flex flex-wrap gap-2",
  "data-testid": "inactive-formations-list"
}

import { ref, computed, watch } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { mdiPlus, mdiChevronDown } from '@mdi/js'
import EditableItemMenu from './EditableItemMenu.vue'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import {
  VMenu,
  VList,
  VListItem,
  VListItemTitle,
  VCard,
  VCardText,
  VAutocomplete,
  VIcon,
  VRow
} from 'vuetify/components'

import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableLevelGroup',
  props: {
    title: {},
    itemLabel: {},
    items: {},
    inactiveItems: {},
    requiresDoctorPaymentFormation: { type: Boolean },
    createButtonLabel: {},
    type: {}
  },
  emits: ["update", "updateRequiresDoctorPaymentFormation", "edit", "deactivate", "reactivate", "create"],
  setup(__props: any, { emit }) {

const props = __props;

const isCreateMenuOpen = ref(false)
const newItemName = ref('')
const options = ref<{ id: number; name: string }[]>([])
const service = new FieldOptionsService()
const { notifyError } = useErrorToast()
const isLoading = ref(false)
const searchText = ref('')



const store = useCreateScheduleStore()

async function fetchOptions() {
  if (options.value.length > 0) return

  isLoading.value = true
  try {
    options.value = await service.getFormations()
  } catch (error) {
    // Carga disparada ao abrir o menu: a lista fica vazia e a próxima abertura tenta de novo.
    notifyError(error, 'Não foi possível carregar as formações.')
  } finally {
    isLoading.value = false
  }
}

watch(isCreateMenuOpen, (isOpen) => {
  if (isOpen) {
    fetchOptions()
  }
})



const levelFilterEnabled = computed<boolean>({
  get: () => props.requiresDoctorPaymentFormation,
  set: (value) => {
    ;(emit('updateRequiresDoctorPaymentFormation', value), store.setFormationRequired(value))
  }
})

function handleCreate() {
  if (!newItemName.value || newItemName.value.trim() === '') {
    return
  }
  emit('create', newItemName.value.trim())
  newItemName.value = ''
  searchText.value = ''
  isCreateMenuOpen.value = false
}

function selectNewItem() {
  newItemName.value = searchText.value
  handleCreate()
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DsSwitch, {
          modelValue: levelFilterEnabled.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((levelFilterEnabled).value = $event)),
          size: "small"
        }, null, 8, ["modelValue"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex gap-2", {
          'filter grayscale opacity-60 pointer-events-none': !levelFilterEnabled.value
        }])
      }, [
        _createVNode(_unref(VMenu), {
          modelValue: isCreateMenuOpen.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isCreateMenuOpen).value = $event)),
          "close-on-content-click": false,
          location: "bottom end"
        }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createElementVNode("button", _mergeProps(menuProps, {
              class: "flex items-center gap-1 font-semibold text-primary30 rounded px-3 py-1 text-sm primary30-btn",
              disabled: !levelFilterEnabled.value
            }), [
              _createTextVNode(_toDisplayString(_ctx.itemLabel) + " ", 1),
              _createVNode(_unref(VIcon), {
                color: "primary",
                icon: _unref(mdiPlus),
                size: "24"
              }, null, 8, ["icon"])
            ], 16, _hoisted_4)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(VCard), { "min-width": "400" }, {
              default: _withCtx(() => [
                _createVNode(_unref(VCardText), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(VRow), { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(VAutocomplete), {
                              modelValue: newItemName.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newItemName).value = $event)),
                              search: searchText.value,
                              "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((searchText).value = $event)),
                              items: options.value,
                              loading: isLoading.value,
                              "item-title": "name",
                              "item-value": "name",
                              label: _ctx.itemLabel,
                              variant: "outlined",
                              density: "compact",
                              "hide-details": "",
                              autofocus: "",
                              onKeydown: _withKeys(handleCreate, ["enter"])
                            }, {
                              "no-data": _withCtx(() => [
                                (searchText.value)
                                  ? (_openBlock(), _createBlock(_unref(VListItem), {
                                      key: 0,
                                      onClick: selectNewItem
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(VListItemTitle), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Adicionar \""),
                                            _createElementVNode("span", _hoisted_5, _toDisplayString(searchText.value), 1),
                                            _createTextVNode("\" ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "search", "items", "loading", "label", "onKeydown"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(FilledButton, {
                              text: _ctx.createButtonLabel || 'Adicionar',
                              color: "primary30",
                              height: "40px",
                              width: "120px",
                              disabled: !newItemName.value || String(newItemName.value).trim() === '',
                              onClick: handleCreate
                            }, null, 8, ["text", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_unref(VMenu), null, {
          activator: _withCtx(({ props: menuProps }) => [
            _createElementVNode("button", _mergeProps(menuProps, {
              class: ["flex items-center gap-1 font-semibold text-primary30 rounded px-3 py-1 text-sm primary30-btn", { 'opacity-50 cursor-not-allowed': _ctx.inactiveItems.length === 0 }],
              disabled: _ctx.inactiveItems.length === 0
            }), [
              _createTextVNode(" Ativar formação "),
              _createVNode(_unref(VIcon), {
                color: "primary",
                icon: _unref(mdiChevronDown),
                size: "24"
              }, null, 8, ["icon"])
            ], 16, _hoisted_6)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(VList), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveItems, (item, index) => {
                  return (_openBlock(), _createBlock(_unref(VListItem), {
                    key: index,
                    onClick: ($event: any) => (_ctx.$emit('reactivate', index)),
                    class: "cursor-pointer"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VListItemTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2", {
        'filter grayscale opacity-60 pointer-events-none': !levelFilterEnabled.value
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createBlock(EditableItemMenu, {
          key: index,
          modelValue: item,
          "onUpdate:modelValue": (val) => _ctx.$emit('update', index, val),
          onEdit: () => _ctx.$emit('edit', index),
          onRename: (val) => _ctx.$emit('update', index, val),
          onDeactivate: () => _ctx.$emit('deactivate', index)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onEdit", "onRename", "onDeactivate"]))
      }), 128))
    ], 2),
    (_ctx.inactiveItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inactiveItems, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                class: "bg-gray-200 px-3 py-1 rounded text-sm flex items-center gap-2"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})